import { BUGSNAG_API_KEY, RELEASE_STAGE } from '@/libs/constants';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import { store } from '@store';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import React from 'react';
import { en, registerTranslation } from 'react-native-paper-dates';
import { Provider as ReduxProvider } from 'react-redux';
import Root from './root';

registerTranslation('en', en);

Bugsnag.start({
  apiKey: BUGSNAG_API_KEY,
  releaseStage: RELEASE_STAGE,
  plugins: [new BugsnagPluginReact()],
});
const ErrorBoundary = Bugsnag.getPlugin('react')?.createErrorBoundary(React);

const App = () => {
  const renderApp = (
    <SafeAreaProvider>
      <ReduxProvider store={store}>
        <Root />
      </ReduxProvider>
    </SafeAreaProvider>
  );

  if (ErrorBoundary) {
    return <ErrorBoundary>{renderApp}</ErrorBoundary>;
  }

  return renderApp;
};

export default App;
